import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "../../utils/axios";
import { showApiError, showApiSuccess } from "../../utils/toast";

export default function ForgotPasswordPage() {
  const logo = new URL(`../../assets/images/logo.png`, import.meta.url);

  const [mobile, setMobile] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate mobile number
    if (!/^[0-9]{10}$/.test(mobile)) {
      showApiError(null, "Please enter a valid 10-digit mobile number");
      return;
    }

    setIsSubmitting(true);

    try {
      await http.post("/dashboard/auth/forgot-password", { mobile });
      showApiSuccess("OTP sent successfully to your mobile number");
      navigate("/reset-password", { state: { mobile } });
    } catch (err) {
      showApiError(err, "Failed to send OTP. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow p-6">
        <div className="w-full justify-center flex-col flex items-center">
          <img src={logo} alt="Logo" className="w-48" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2 text-center">
            Forgot Password
          </h1>
          <p className="text-gray-600 text-center mb-6">
            Enter your mobile number to receive an OTP
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mobile Number
            </label>
            <input
              type="tel"
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter 10-digit mobile number"
              maxLength={10}
              required
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 transition-colors disabled:bg-blue-400 flex items-center justify-center"
          >
            {isSubmitting ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Sending OTP...
              </>
            ) : (
              "Send OTP"
            )}
          </button>

          <div className="text-center mt-4">
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="text-blue-600 hover:text-blue-700 text-sm"
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
